import { getUniqueListBy } from "@components/Common/Function";
import { getRmdmTownApi } from "@services/rmdm/getRmdmTownApi";
import { getClusterCodeApi } from "@services/zsm/getClusterCodeApi";
import { getTerritoryApi } from "@services/MarketWorking/MyTeam/getTerritoryApi";
import {
  GET_CLUSTER_CODE_FAIL,
  GET_CLUSTER_CODE_SUCCESS,
  GET_TERRITORY_SUCCESS,
  GET_TERRITORY_FAIL,
} from "../constants/action-types";

export const getRMDMClusterCode = (Title, Email) => async (dispatch) => {

  const response = await getClusterCodeApi("", Title, "", "", Email);
  if (response?.success === true) {
    let arr = [];
    const data = getUniqueListBy(response?.data?.records, "CLUSTER_CODE__c");
    data?.forEach((item) => {
      arr.push(item?.CLUSTER_CODE__c);
    });
    await dispatch(getRmdmTownApi(arr));

    // Load territory using cluster codes via SH3_Code__c IN (...) as per business logic
    const clusterCodesForQuery = arr.map((code) => `'${code}'`).join(", ");
    const territoryResponse = await getTerritoryApi({ UserSH_Code__c: clusterCodesForQuery, Title });
    if (territoryResponse?.success === true) {
      dispatch({
        type: GET_TERRITORY_SUCCESS,
        payload: territoryResponse?.data?.records,
      });
    } else {
      dispatch({ type: GET_TERRITORY_FAIL });
    }

    dispatch({
      type: GET_CLUSTER_CODE_SUCCESS,
      payload: response?.data?.records,
    });
  } else {
    dispatch({ type: GET_CLUSTER_CODE_FAIL });
  }
};
